import React, { useState } from 'react';
import { useUser } from '../contexts/UserContext';
import { useToast } from '../contexts/ToastContext';

const ChangePasswordModal = ({ onClose }) => {
  const { user } = useUser();
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState('');
  const { addToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== passwordConfirmation) {
      setError("New passwords do not match.");
      return;
    }

    if (!user) {
      setError("You must be logged in to change your password.");
      return;
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const response = await fetch(`/api/v1/users/${user.id}/password`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify({
        user: {
          current_password: currentPassword,
          password,
          password_confirmation: passwordConfirmation,
        },
      }),
    });

    const data = await response.json();

    if (response.ok) {
      addToast('Password updated successfully!', 'success');
      onClose();
    } else {
      setError(data.errors ? data.errors.join(', ') : 'Failed to update password.');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <article className="modal-content" onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <h2>Change Password</h2>
          <button aria-label="Close" className="close-button" onClick={onClose}>&times;</button>
        </header>
        <form onSubmit={handleSubmit}>
          {error && <p style={{ color: 'var(--pico-color-red-550)' }}>{error}</p>}

          <label htmlFor="current_password">Current Password</label>
          <input
            type="password"
            id="current_password"
            name="current_password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />

          <label htmlFor="new_password">New Password</label>
          <input
            type="password"
            id="new_password"
            name="new_password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength="8"
          />

          <label htmlFor="password_confirmation">Confirm New Password</label>
          <input
            type="password"
            id="password_confirmation"
            name="password_confirmation"
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            required
          />

          <button type="submit">Update Password</button>
        </form>
      </article>
    </div>
  );
};

export default ChangePasswordModal;